<template>
  <div id="dance">
    <div class="row mt-md-5 text-center">
      <div class="col-md-12 title-image">
        <img src="/static/images/dance/title.png" class="img-fluid" alt="おひさまキッチンのどうぶつさん達の画像">
      </div>
      <div class="col-md-12">
        <h2>
          えほんのなかで、パンダくんやどうぶつさんが唄ったり踊ったりしています。みんなも一緒に踊って唄ってみてね！
        </h2>
      </div>
      <div class="col-md-12 line">
        <img src="/static/images/common/line.png" class="img-fluid" alt="黄色の破線">
      </div>
      <div class="col-md-12" id="sample-movie">
        <div class="card title-image">
          <img src="/static/images/dance/tanetane.png" class="img-fluid" alt="タネタネダンスタイトル">
        </div>
        <div class="card sample-movie">
          <img src="/static/images/campaign/tanetane/2020_tanetane_doga_waku.png" class="img-fluid waku-img" alt="タネタネダンスフレーム">
          <div class="card-img-overlay">
          <b-embed
            type="iframe"
            aspect="16by9"
            src="https://www.youtube.com/embed/Zde6x_vdaoQ?rel=0"
            allowfullscreen
          ></b-embed>
          </div>
         <div class="full-width"></div>
        </div>
      </div>
      <div class="col-md-12 lyric">
        <p>歌詞</p>
        <p>タネ　タネ　タネ　タネ x ４</p>
        <p class="pt-3 pb-3">つないダネ　おどっタネ　わらっタネ　なかよくなっタネ</p>
        <p>タネ　タネ　タネ　タネ x ４</p>
        <p class="pt-3 pb-3">おこっタネ　なーいタネ　おやつダネ　なかよくなっタネ</p>
        <p>タネ　タネ　タネ　タネ x ４</p>
        <p class="pt-3 pb-3">はしっタネ　うたっタネ　およいダネ　なかよくなっタネ</p>
        <p>タネ　タネ　タネ　タネ x ４</p>
        <p>タネ　タネ　タネ　タネ x ３</p>
        <p>タネ　タネ</p>
        <p class="pt-3 pb-3">さいタネ！</p>
      </div>

      <div class="col-md-12 line">
        <img src="/static/images/common/line.png" class="img-fluid" alt="黄色の破線">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    title: 'いっしょにおどろう！パンダくんのダンスだよ',
    name: 'dance',
    mounted: function() {
      this.$nextTick(function () {
        try {
          FONTPLUS.reload();
        } catch (error) {
          console.log(error.message);
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dance.vue